/* ODAVIA rotator (hero + announcement) — original code
   - Hero: rotates only with 2+ slides and autoplay on.
   - Announcement bar (.odavia-bar): from 1200px all messages are shown side by side
     (static, no interval); below 1200px it rotates.
   - Pauses on hover/focus, a tap toggles pause on touch devices,
     no auto-rotation with prefers-reduced-motion. */
(function(){
  if (customElements.get('odavia-rotator')) return;
  var TOUCH_GRACE = 800;
  class OdaviaRotator extends HTMLElement {
    connectedCallback(){
      if (this.__init) { this.attachGlobal(); this.applyMode(); return; }
      this.items = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      if (this.items.length < 2) return;
      this.__init = true;
      this.i = 0;
      this.speed = parseInt(this.dataset.speed || '5000', 10);
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.auto = this.dataset.autorotate !== 'false' && !this.reduced;
      this.hovering = false;
      this.focused = false;
      this.userPaused = false;
      this.touchTs = 0;
      this.mq = this.classList.contains('odavia-bar') ? window.matchMedia('(min-width: 1200px)') : null;

      this.onMq = () => this.applyMode();
      this.onVis = () => { if (document.hidden) this.stop(); else this.resume(); };
      this.addEventListener('mouseenter', () => {
        if (Date.now() - this.touchTs < TOUCH_GRACE) return;
        this.hovering = true; this.stop();
      });
      this.addEventListener('mouseleave', () => {
        if (Date.now() - this.touchTs < TOUCH_GRACE) return;
        this.hovering = false; this.resume();
      });
      this.addEventListener('focusin', () => { this.focused = true; this.stop(); });
      this.addEventListener('focusout', (e) => {
        if (e.relatedTarget && this.contains(e.relatedTarget)) return;
        this.focused = false; this.resume();
      });
      this.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse') return;
        this.touchTs = Date.now();
        this.userPaused = !this.userPaused;
        if (this.userPaused) this.stop(); else this.resume();
      });
      this.dots.forEach((d, idx) => d.addEventListener('click', () => { this.show(idx); }));
      this.attachGlobal();
      this.show(0);
      this.applyMode();
    }
    attachGlobal(){
      if (this.__global) return;
      this.__global = true;
      document.addEventListener('visibilitychange', this.onVis);
      if (this.mq) {
        if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMq);
        else if (this.mq.addListener) this.mq.addListener(this.onMq);
      }
    }
    detachGlobal(){
      if (!this.__global) return;
      this.__global = false;
      document.removeEventListener('visibilitychange', this.onVis);
      if (this.mq) {
        if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMq);
        else if (this.mq.removeListener) this.mq.removeListener(this.onMq);
      }
    }
    isStatic(){ return !!(this.mq && this.mq.matches); }
    applyMode(){
      if (this.isStatic()) {
        this.stop();
        this.classList.add('is-static');
        this.items.forEach((el) => {
          el.classList.add('is-active');
          el.setAttribute('aria-hidden', 'false');
        });
      } else {
        this.classList.remove('is-static');
        this.show(this.i || 0);
        this.resume();
      }
    }
    show(n){
      if (this.isStatic()) return;
      this.i = (n + this.items.length) % this.items.length;
      this.items.forEach((el, idx) => {
        el.classList.toggle('is-active', idx === this.i);
        el.setAttribute('aria-hidden', idx === this.i ? 'false' : 'true');
      });
      this.dots.forEach((d, idx) => d.setAttribute('aria-current', idx === this.i ? 'true' : 'false'));
    }
    resume(){
      if (!this.auto || this.userPaused || this.hovering || this.focused || document.hidden || this.isStatic()) return;
      this.start();
    }
    start(){ this.stop(); this.t = setInterval(() => this.show(this.i + 1), this.speed); }
    stop(){ if (this.t) clearInterval(this.t); this.t = null; }
    disconnectedCallback(){
      this.stop();
      if (this.__init) this.detachGlobal();
    }
  }
  customElements.define('odavia-rotator', OdaviaRotator);
})();
